import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Message, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly translate = inject(TranslateService);
  private readonly message = inject(MessageService);

  add(message: Message) {
    this.message.add({
      ...message,
      detail: message.detail ? this.translate.instant(message.detail) : undefined,
      summary: message.summary ? this.translate.instant(message.summary) : undefined,
      styleClass: 'custom-toast',
    });
  }
}
